import { createSelector } from '@reduxjs/toolkit';

export const forDownloadStoreStateSelector = (state) =>
  state.forDownload;

export const forDownloadTicketsSelector = createSelector(
  forDownloadStoreStateSelector,
  (storeState) => storeState.tickets,
);

export const forDownloadIsLoadingSelector = createSelector(
  forDownloadStoreStateSelector,
  (storeState) => storeState.isLoading,
);
